function GenericConfiguration() {
	// handles routes that are not part of the quote process
}
